module.exports = __webpack_public_path__ + "static/media/fly0266.38c4414a.webp";